import { update } from "@intercom/messenger-js-sdk";
import { PaletteMode } from "@mui/material";

import { MODE_STORAGE_KEY } from "./storageKeys";

export type IntercomThemeMode = PaletteMode;

export const getStoredIntercomThemeMode = (): IntercomThemeMode => {
  if (typeof window === "undefined") {
    return "light";
  }

  const stored = localStorage.getItem(MODE_STORAGE_KEY);
  return stored === "dark" ? "dark" : "light";
};

/** Apply Intercom theme immediately (same tick as MUI setMode). */
export const syncIntercomThemeMode = (mode: IntercomThemeMode): void => {
  if (typeof window === "undefined" || typeof window.Intercom !== "function") {
    return;
  }

  update({ theme_mode: mode });
};
